import { render, staticRenderFns } from "./BrandCreateTraining.vue?vue&type=template&id=644f8dfa&scoped=true"
import script from "./BrandCreateTraining.vue?vue&type=script&lang=js"
export * from "./BrandCreateTraining.vue?vue&type=script&lang=js"
import style0 from "./BrandCreateTraining.vue?vue&type=style&index=0&id=644f8dfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f8dfa",
  null
  
)

export default component.exports